import React from 'react'
import { PageHeaderWithButtons } from 'components/shared'
import { AppUrls } from 'common/AppUrls'
import { useTranslation } from 'react-i18next'

import './About.scss'
import { AppVersion, AppVersionAnotation } from 'common/Globals'

export const About = () => {
    const { t } = useTranslation()

    return (
        <>
            <PageHeaderWithButtons backUrl={AppUrls.settings} pageName={t('about')} />
            <div className="about__item d-flex justify-content-between align-items-center">
                <p>
                    <span className="h6">{t('version')}: </span>
                    {AppVersion} {AppVersionAnotation}
                </p>
            </div>
        </>
    )
}
